import PropTypes from 'prop-types';
import React from 'react';
import { Chip, ChipRow, FillInput, FillTextarea, controlA11y } from './styles';

// Short answer, long answer, number and email: one text control each.

export const inputPropTypes = {
  field: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  inputId: PropTypes.string.isRequired,
  labelId: PropTypes.string.isRequired,
  describedBy: PropTypes.string,
  invalid: PropTypes.bool,
};

const text = (value) => (typeof value === 'string' ? value : '');

export const ShortAnswerInput = (props) => {
  const { field, value, onChange, invalid } = props;
  return (
    <FillInput
      {...controlA11y(props)}
      value={text(value)}
      onChange={(e) => onChange(e.target.value)}
      placeholder={field.placeholder || ''}
      $invalid={invalid}
    />
  );
};
ShortAnswerInput.propTypes = inputPropTypes;

export const LongAnswerInput = (props) => {
  const { field, value, onChange, invalid } = props;
  return (
    <FillTextarea
      {...controlA11y(props)}
      rows={4}
      value={text(value)}
      onChange={(e) => onChange(e.target.value)}
      placeholder={field.placeholder || ''}
      $invalid={invalid}
    />
  );
};
LongAnswerInput.propTypes = inputPropTypes;

export const NumberInput = (props) => {
  const { field, value, onChange, invalid } = props;
  return (
    <FillInput
      {...controlA11y(props)}
      inputMode="decimal"
      value={text(value)}
      onChange={(e) => onChange(e.target.value)}
      placeholder={field.placeholder || ''}
      $invalid={invalid}
    />
  );
};
NumberInput.propTypes = inputPropTypes;

export const EMAIL_DOMAINS = [
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'hotmail.com',
  'icloud.com',
  'aol.com',
];

// Replaces whatever follows "@" with the tapped domain.
export const withDomain = (value, domain) =>
  `${text(value).split('@')[0]}@${domain}`;

export const EmailInput = (props) => {
  const { field, value, onChange, invalid } = props;
  return (
    <div>
      <FillInput
        {...controlA11y(props)}
        type="email"
        inputMode="email"
        autoComplete="off"
        value={text(value)}
        onChange={(e) => onChange(e.target.value)}
        placeholder={field.placeholder || 'name@example.com'}
        $invalid={invalid}
      />
      <ChipRow>
        {EMAIL_DOMAINS.map((domain) => (
          <Chip
            key={domain}
            onClick={() => onChange(withDomain(value, domain))}
          >
            @{domain}
          </Chip>
        ))}
      </ChipRow>
    </div>
  );
};
EmailInput.propTypes = inputPropTypes;
